import { useShallow } from "zustand/react/shallow";
import { AppPermissions } from "models/permissions/permissions";
import { useRootStore } from "store";

export function usePermissions(): AppPermissions {
  return useRootStore(useShallow((state) => state.user.permissions));
}

export function usePermission<K extends keyof AppPermissions>(key: K): AppPermissions[K] {
  return useRootStore((state) => state.user.permissions[key]);
}
